import APIS from "../../constant/EndPoint";
import { classNames } from "../../utils/classNames";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import {
  UseFormRegister,
  FieldErrors,
  UseFormSetValue,
  UseFormGetValues,
  UseFormReset,
  UseFormWatch,
  UseFormClearErrors,
  Control,
  Controller,
} from "react-hook-form";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import { IFilterRoles } from "./UserList";
import SelectField from "../Reusable/SelectField/SelectField";

interface Props {
  register: UseFormRegister<IFilterRoles>;
  errors: FieldErrors<IFilterRoles>;
  setValue: UseFormSetValue<IFilterRoles>;
  getValues: UseFormGetValues<IFilterRoles>;
  reset: UseFormReset<IFilterRoles>;
  watch: UseFormWatch<IFilterRoles>;
  clearErrors: UseFormClearErrors<IFilterRoles>;
  control: Control<IFilterRoles, any>;
  isFilterVisible: boolean;
}
const FilterData = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
  { id: "staff", name: "Staff" },
  { id: "superuser", name: "Super User" },
];
const RolesFilter = ({ reset, control, isFilterVisible }: Props) => {
  return (
    <div
      className={classNames(
        isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-3 items-center gap-x-4 mx-4`}>
          <ComboboxFilter<IFilterRoles>
            url={APIS.ROLES}
            queryKey={"roles"}
            params={{
              is_active: true,
            }}
            name={"roles"}
            control={control}
            label={"Roles"}
            placeholder={"Select Roles"}
          />
          <div className={tw`mt-3`}>
            <Controller
              name="user_type"
              control={control}
              render={({ field }) => (
                <SelectField
                  label="User Type"
                  options={FilterData}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <button
            className={tw`absolute -top-5 right-5`}
            onClick={() => reset()}
          >
            Reset
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default RolesFilter;
